import type { Ref } from 'vue'
import { computed, nextTick, onMounted, ref } from 'vue'

/**
 * 创建显示支付方式选择器的计算属性
 * 当可用支付方式数量大于 1 时显示
 */
export function createShowPaymentMethodSelector(
  availablePaymentMethods: Ref<any[]>,
) {
  return computed(() => {
    return availablePaymentMethods.value?.length > 1
  })
}

/**
 * 创建检测内容高度是否需要固定底部支付方式的逻辑
 */
export function useFixedBottomPayment() {
  const isFixedBottom = ref(false)
  const containerRef = ref<HTMLElement | null>(null)

  function checkContentHeight() {
    nextTick(() => {
      if (!containerRef.value)
        return

      // 获取容器内所有子元素的实际高度总和
      const children = containerRef.value.children
      let actualContentHeight = 0
      for (let i = 0; i < children.length; i++)
        actualContentHeight += (children[i] as HTMLElement).offsetHeight

      const viewportHeight = window.innerHeight

      // 如果实际内容高度 + navbar高度 + 边距 接近视口高度，则固定在底部
      isFixedBottom.value = actualContentHeight >= viewportHeight - 100
    })
  }

  onMounted(() => {
    checkContentHeight()
    window.addEventListener('resize', checkContentHeight)
  })

  return {
    isFixedBottom,
    containerRef,
    checkContentHeight,
  }
}
